<template>
    <div class="homepage d-flex flex-column vh-100">
        <!-- navbar -->
        <div class="d-flex align-items-center gap-3 p-3 bg-primary">
            <span @click="$router.go(-1)" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span>
            <div>
                <h6 class="fw-bold text-white mb-0">Daily Needs</h6>
                <p class="text-white-50 small m-0">To Home</p>
            </div>
        </div>
        <!--start------------------------------------------------------- body----------------------------------------------------------------------------->
        <div>
            <div class="card-header text-center mt-2">
                <h3>Daily Needs</h3>
            </div>
        
            <div class="row">
                <div class="col-12" v-for="(cat, i) in dailyneedlist" :key="i">
                  <div class="card listItem ">
                   <a :href="'tel:' + cat.contact">
                      <div class="card-body row align-items-center">
                        <div class="col-4">
                             <img  :src="$asset_path+'dailyneed/'+cat.img" width="100%"/>
                           
                        </div>
                         
                        <div class="col-8">
                          <h6 class="card-title fw-bold m-0">{{ cat.name }}</h6>
                          <p class="card-text small text-muted m-0">
                            <i class="bi bi-telephone"></i>
                            <a :href="'tel:' + cat.contact" class="text-decoration-none text-muted">{{ cat.contact }}</a>
                          </p>                          
                          <p class="card-text small text-muted m-0">{{ cat.description }}</p>
                        </div>
                      </div>
                   </a>
                  </div>
                </div>
              </div>
              
              




        </div>
        


        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->












        <!-- footer -->
        <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>

    </div>
</template>

<style scoped>
    
.listItem{
     position: relative;
    background: #fff;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
    margin: 0px 5px;
    border-radius: 5px;
}
    .hover-zoom {
        transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    }

    .hover-zoom:hover {
        transform: scale(1.05);
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    }

    .custon-design {
        text-transform: capitalize;
        background-color: bisque;
    }

    .custom-btn {
        background: linear-gradient(328deg, #ff0000, #000199);
        border: none;
        /* Remove Bootstrap's default border */
        color: white;
        /* Ensure text is readable */
    }
</style>



<script>
    import axios from "@/plugins/axios";
import {
  fetchDailyneeds
} from  "@/plugins/apiService";
    export default {
        name: 'HomeView',
        components: {
        },
        mounted() {
            this.getHomeBasic();
        },
        data() {
            return {
                loading: false,
                error: null,
                dailyneedlist: [],
                foodcategories:[],
                businesscategories:[],

             

            }
        },
    
        methods: {
           


            newregister() {

                alert("hello")


            },
            previous_food(){
                this.isFood = false;
            },



            async getHomeBasic() {
                // this.loading = true;
                this.error = null;
 fetchDailyneeds() .then((res) => {this.dailyneedlist = res.data;}).catch(() => {this.error = "Failed to load categories.";}).finally(() => { });
                // try {
                //     var self = this;
                //     axios.post("getfrontview").then((response) => {
                //         self.dailyneedlist = response.data.dailyneedlist;
                //         self.foodcategories = response.data.foodcategories;
                //         self.businesscategories = response.data.businesscategories;
                //         self.events = response.data.events;
                //         self.listings = response.data.businesslisting;
                //         self.properties = response.data.properties;
                //         self.isUserLogged = response.data.isUserLogged;


                //     }).then(() => {
                //         self.initializeHomeContent();
                //     }).catch((err) => {

                //     });;


                // } catch (err) {
                //     this.error = err.response?.data?.message || "Login failed. Please try again.";
                // } finally {
                //     this.loading = false;
                // }
            },

         


        }
    }





</script>